/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DatasetPipelineList } from './DatasetPipelineList';
import {
  DatasetPipelineListFromJSON,
  DatasetPipelineListFromJSONTyped,
  DatasetPipelineListToJSON,
} from './DatasetPipelineList';

/**
 *
 * @export
 * @interface PaginatedDatasetPipelineListList
 */
export interface PaginatedDatasetPipelineListList {
  /**
   *
   * @type {number}
   * @memberof PaginatedDatasetPipelineListList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedDatasetPipelineListList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedDatasetPipelineListList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<DatasetPipelineList>}
   * @memberof PaginatedDatasetPipelineListList
   */
  results: Array<DatasetPipelineList>;
}

/**
 * Check if a given object implements the PaginatedDatasetPipelineListList interface.
 */
export function instanceOfPaginatedDatasetPipelineListList(value: object): value is PaginatedDatasetPipelineListList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedDatasetPipelineListListFromJSON(json: any): PaginatedDatasetPipelineListList {
  return PaginatedDatasetPipelineListListFromJSONTyped(json, false);
}

export function PaginatedDatasetPipelineListListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedDatasetPipelineListList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(DatasetPipelineListFromJSON),
  };
}

export function PaginatedDatasetPipelineListListToJSON(value?: PaginatedDatasetPipelineListList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(DatasetPipelineListToJSON),
  };
}
